export default "__VITE_ASSET__BXP$rCLJ__"